import React from 'react';
import "./Wings.css"

function SharkyTizers() {

    return (
<div class="menuList">
<div className="wing-container">
        <div className="col">Mozzarella Sticks</div> <div className="dots"></div>{" "}
        <div className="col">$5.99</div>
      </div>
      <div className="wing-container">
        <div className="col">Fried Mushrooms</div> <div className="dots"></div>{" "}
        <div className="col">$5.99</div>
      </div>
      <div className="wing-container">
        <div className="col">Perogies</div> <div className="dots"></div>{" "}
        <div className="col">$7.99</div>
      </div>
      <div className="wing-container">
        <div className="col">Mac & Cheese Wedges</div> <div className="dots"></div>{" "}
        <div className="col">$7.99</div>
      </div>
      <div className="wing-container">
        <div className="col">Fried Ravioli</div> <div className="dots"></div>{" "}
        <div className="col">$5.99</div>
      </div>
      <div className="wing-container">
        <div className="col">Fried Pickle Chips</div> <div className="dots"></div>{" "}
        <div className="col">$6.99</div>
      </div>
      <div className="wing-container">
        <div className="col">Broccoli Bites</div> <div className="dots"></div>{" "}
        <div className="col">$7.99</div>
      </div>
      <div className="wing-container">
        <div className="col">Southwest Egg Rolls</div> <div className="dots"></div>{" "}
        <div className="col">$8.99</div>
      </div>
      <div className="wing-container">
        <div className="col">Potato Skins (5 Piece)</div> <div className="dots"></div>{" "}
        <div className="col">$10.99</div>
      </div>
      <div className="wing-container">
        <div className="col">Nachos Supreme</div> <div className="dots"></div>{" "}
        <div className="col">$10.99</div>
      </div>
      <div className="wing-container">
        <div className="col">Pretzel Nuggets</div> <div className="dots"></div>{" "}
        <div className="col">$4.99</div>
      </div>
      <div className="wing-container">
        <div className="col">Giant Pretzel</div> <div className="dots"></div>{" "}
        <div className="col">$12.99</div>
      </div>
      <div className="wing-container">
        <div className="col">Pretzel Cheese Curds</div> <div className="dots"></div>{" "}
        <div className="col">$7.99</div>
      </div>
</div>

    )
}

export default SharkyTizers